import { ROLE_LABELS as SHARED_ROLE_LABELS } from '@trinco/shared';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL ?? 'https://api.trinco.io';

export const APP_NAME = 'Trinco';

export const DEAL_STAGE_COLORS: Record<string, string> = {
  lead: '#6B7280',
  prospect: '#3B82F6',
  negotiating: '#F59E0B',
  verbal: '#8B5CF6',
  signed: '#10B981',
  active: '#059669',
  churned: '#EF4444',
};

export const ROLE_LABELS = SHARED_ROLE_LABELS;
